'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _f3tch = require('f3tch');

var _f3tch2 = _interopRequireDefault(_f3tch);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (id) {
  return (0, _f3tch2.default)('/vehicles/' + id + '/mileage/').profile('json').get();
};